<template lang="">
  <div class="modal width2">
    <a class="modal_close" @click="closeModal"></a>
    <div class="modal_header">
      <div class="title">후기 작성</div>
    </div>
    <div class="modal_body">
      <ul class="modal_list type2">
        <li>작성하신 평가내용은 다른 분의 구매에 많은 도움이 됩니다.</li>
        <li>
          해당 게시판의 목적과 관계 없는 글, 광고성, 욕설, 비방 등의 글은 예고
          없이 삭제 됩니다.
        </li>
      </ul>
      <div class="modal_tbl type2">
        <table>
          <tbody>
            <tr>
              <th>상품명</th>
              <td class="name">{{ this.campaignInfo.campaignName }}</td>
            </tr>
            <tr>
              <th>후원단체</th>
              <td>
                <div class="wrapper">
                  <p>{{ this.campaignInfo.partnerCompany }}</p>
                  <div class="chk_wrap">
                    <input
                      type="checkbox"
                      id="exposure"
                      name="exposure"
                      v-model="review.showPartnerCompany"
                    />
                    <label for="exposure" class="chk_btn">
                      <span>후원단체 노출 선택</span>
                    </label>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th>평가</th>
              <td>
                <div class="wrapper rating">
                  <fieldset class="rate">
                    <input
                      type="radio"
                      id="rating10"
                      name="rating"
                      value="5"
                      v-model="review.reviewRating"
                    /><label for="rating10" title="5점"></label>
                    <input
                      type="radio"
                      id="rating9"
                      name="rating"
                      value="4.5"
                      v-model="review.reviewRating"
                    /><label class="half" for="rating9" title="4.5점"></label>
                    <input
                      type="radio"
                      id="rating8"
                      name="rating"
                      value="4"
                      v-model="review.reviewRating"
                    /><label for="rating8" title="4점"></label>
                    <input
                      type="radio"
                      id="rating7"
                      name="rating"
                      value="3.5"
                      v-model="review.reviewRating"
                    /><label class="half" for="rating7" title="3.5점"></label>
                    <input
                      type="radio"
                      id="rating6"
                      name="rating"
                      value="3"
                      v-model="review.reviewRating"
                    /><label for="rating6" title="3점"></label>
                    <input
                      type="radio"
                      id="rating5"
                      name="rating"
                      value="2.5"
                      v-model="review.reviewRating"
                    /><label class="half" for="rating5" title="2.5점"></label>
                    <input
                      type="radio"
                      id="rating4"
                      name="rating"
                      value="2"
                      v-model="review.reviewRating"
                    /><label for="rating4" title="2점"></label>
                    <input
                      type="radio"
                      id="rating3"
                      name="rating"
                      value="1.5"
                      v-model="review.reviewRating"
                    /><label class="half" for="rating3" title="1.5점"></label>
                    <input
                      type="radio"
                      id="rating2"
                      name="rating"
                      value="1"
                      v-model="review.reviewRating"
                    /><label for="rating2" title="1점"></label>
                    <input
                      type="radio"
                      id="rating1"
                      name="rating"
                      value="0.5"
                      v-model="review.reviewRating"
                    /><label class="half" for="rating1" title="0.5점"></label>
                  </fieldset>
                  <p class="rating_txt">{{ getRatingText }}</p>
                </div>
              </td>
            </tr>
            <tr>
              <th>상품평</th>
              <td>
                <textarea v-model="review.reviewText"> </textarea>
              </td>
            </tr>
            <tr>
              <th>사진등록 (선택)</th>
              <td>
                <div class="wrapper" @click="triggerFileInput">
                  <input type="text" readonly class="file_input" />
                  <button class="btn_addFile">파일찾기</button>
                  <input
                    type="file"
                    ref="fileInput"
                    accept="image/*"
                    multiple
                    @change="handleFileChange"
                    style="display: none"
                  />
                </div>
                <span class="addFile_txt"
                  >확장자 JPG, GIF, PNG / 용량 10M 이하</span
                >
                <div class="wrapper">
                  <ul class="img_list">
                    <li v-for="(attach, index) in attachList" :key="index">
                      <img :src="attach.preview" alt="미리보기 이미지" />
                      <a class="btn_fileDel" @click="removeAttach(index)"></a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="common_btn type2">
        <button type="button" class="btn_cancel" @click="closeModal">
          취소
        </button>
        <button type="button" class="btn_ok" @click="createReview">확인</button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";

const invitationModule = "invitationModule";
const reviewModule = "reviewModule";

export default {
  props: {
    orderNum: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      campaignInfo: {},

      showPartnerCompany: false,
      review: {
        orderNum: this.orderNum,
        showPartnerCompany: "",
        reviewRating: 0.0,
        reviewText: "",
      },
      attachList: [],
    };
  },

  methods: {
    ...mapActions(invitationModule, ["requestInvitation"]),
    ...mapActions(reviewModule, ["requestCreateReview"]),

    closeModal() {
      this.$emit("closeModal");
    },

    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    handleFileChange(event) {
      const files = event.target.files;
      if (!files.length) return;
      if (files.length + this.attachList.length > 5) {
        this.$openModal("alertModal", {
          message: "사진은 최대 5장만 업로드 가능합니다.",
        });
        return;
      }
      const newFiles = Array.from(files).map((file) => ({
        name: file.name,
        file: file,
        preview: URL.createObjectURL(file),
      }));
      this.attachList = [...this.attachList, ...newFiles];
    },

    removeAttach(idx) {
      this.attachList.splice(idx, 1);
    },

    async createReview() {
      const { review, attachList } = this;

      if (review.reviewRating == 0) {
        this.$openModal("alertModal", {
          message: "별점을 선택해주세요.",
        });
        return;
      } else if (review.reviewText == "") {
        this.$openModal("alertModal", {
          message: "상품평을 입력해주세요.",
        });
        return;
      }
      const formData = new FormData();
      formData.append(
        "review",
        new Blob([JSON.stringify(review)], { type: "application/json" })
      );
      attachList.forEach((attach) => {
        if (attach.file) formData.append("attachList", attach.file);
      });

      const result = await this.requestCreateReview(formData);
      if (result) {
        this.$openModal("alertModal", {
          message: "후기가 등록되었습니다.",
        });
        this.$emit("reviewCreated");
        this.$emit("closeModal");
      }
    },
  },

  computed: {
    ...mapState(invitationModule, ["invitation"]),

    getRatingText() {
      const rating = Number(this.review.reviewRating);
      if (!rating) return "별점을 선택해주세요!";
      if (rating >= 4.5) return "매우 만족";
      if (rating >= 3.5) return "만족";
      if (rating >= 2.5) return "보통";
      if (rating >= 1.5) return "불만족";
      return "매우 불만족";
    },
  },

  async mounted() {
    await this.requestInvitation(this.orderNum);
    if (this.invitation.invitationType == "F") {
      this.campaignInfo = this.invitation.funeralInfo.campaign;
    } else {
      this.campaignInfo = this.invitation.weddingInfo.campaign;
    }
  },
};
</script>
<style lang=""></style>
